<template>
  <v-dialog
    v-model="showModal"
    max-width="600px"
    :dark="darkEnabled"
    @click:outside="fecharModal"
  >
    <v-card :dark="darkEnabled">
      <v-card-title class="pa-6">
        <div class="mx-auto">
          <span class="text-h5 d-block">Alterar senha do cliente</span>
        </div>
      </v-card-title>
      <v-divider />
      <v-card-text class="pa-6 pt-4">
        <v-text-field
          v-model="newPassword"
          label="Senha"
          type="password"
          outlined
          dense
          rounded
          flat
          :dark="darkEnabled"
          :error-messages="erroSenha ? ['Informe a senha'] : []"
          class="mb-2 mt-5"
          autocomplete="new-password"
          @input="val => dadosInput({ model: 'newPassword', value: val })"
        />
        <v-text-field
          v-model="confirmNewPassword"
          label="Confirme a senha"
          type="password"
          outlined
          dense
          rounded
          flat
          :dark="darkEnabled"
          :error-messages="erroConfirmeSenha ? ['As senhas não coincidem'] : []"
          autocomplete="new-password"
          @input="
            val => dadosInput({ model: 'confirmNewPassword', value: val })
          "
        />
      </v-card-text>
      <v-divider />
      <v-card-actions class="pa-4">
        <v-spacer />
        <FormButton text="Fechar" type="perigo" @click="fecharModal" />
        <FormButton text="Salvar" type="submissao" @click="salvarNovaSenha" />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import FormButton from "@/components/form/FormButton";

export default {
  name: "ClienteAlterarSenhaModal",
  components: { FormButton },
  emits: ["closeModal", "saveNewPassword"],
  data() {
    return {
      showModal: false,
      newPassword: "",
      confirmNewPassword: "",
      erroSenha: false,
      erroConfirmeSenha: false
    };
  },
  computed: {
    ...mapGetters(["darkEnabled"])
  },
  methods: {
    fecharModal() {
      this.showModal = false;
      this.newPassword = "";
      this.confirmNewPassword = "";
      this.erroSenha = false;
      this.erroConfirmeSenha = false;
      this.dadosInput({ model: "newPassword", value: "" });
      this.dadosInput({ model: "confirmNewPassword", value: "" });
    },
    abrirModal() {
      this.showModal = true;
    },
    dadosInput({ model, value }) {
      if ((!this.newPassword && !this.confirmNewPassword) || this.newPassword) {
        this.erroSenha = false;
      } else if (!this.newPassword) {
        this.erroSenha = true;
      }

      if (this.confirmNewPassword !== this.newPassword) {
        this.erroConfirmeSenha = true;
      } else {
        this.erroConfirmeSenha = false;
      }

      this.$emit(`update:${model}`, value);
    },
    salvarNovaSenha() {
      const ok =
        this.newPassword === this.confirmNewPassword &&
        this.newPassword &&
        this.confirmNewPassword !== "";

      if (ok) {
        this.$emit("saveNewPassword");
        this.fecharModal();
        return;
      }

      this.erroSenha = !this.newPassword;
      this.erroConfirmeSenha =
        Boolean(this.newPassword) &&
        this.confirmNewPassword !== this.newPassword;
    }
  }
};
</script>
